<template>
  <Link :href="href" target="_blank" :underline="true">{{
    $t('mo-fa-you-yan-zi-dong-xu-fei-xie-yi')
  }}</Link>
</template>

<script setup lang="ts">
import { getGlobalConfig } from '@rendora/common/utils/config';
import { Link } from '@rendora/design/components/link/index';
const isCN = getGlobalConfig().isCN;
const href = isCN
  ? 'https://frontend-protocol.xmov.ai/youyan-v3/subscription'
  : 'https://protocol.rendora.ai/legal/subscription';
</script>
